<template>
  <div class="freeEditorial freeEditorialParsys parsys">
    <div class="contentZone section">
      <div class="content-zone container">
        <div class="link-zone">
          <div class="columns parsys">
            <div class="title">
            <div class="grid-row">
              <div class="col-centered col-6 center">
                <div class="c_004 ">
                    <div class="heading-group">
                      <h2>
                        <span v-html="$store.state.texts.title"></span>
                      </h2>
                    </div>
                </div>
              </div>
            </div>
          </div>
            <div class="columns column section columns12">
              <div class="grid-row">
                <div class="col-centered col-6 center">
                  <div>
                    <div class="form section">
                      <div class="c_019">
                        <form novalidate="">
                          <fieldset>
                            <div class="parsys formBuilder">
                              <car></car>
                              <services></services>
                              <dealer></dealer>
                              <user></user>
                              <submit></submit>
                            </div>
                          </fieldset>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Car from '@/components/form/Car'
import Services from '@/components/form/Services'
import Dealer from '@/components/form/Dealer'
import User from '@/components/form/User'
import Submit from '@/components/form/Submit'

export default {
  name: 'Form',
  components: {
    Car,
    Services,
    Dealer,
    User,
    Submit
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .form-centered {
    padding: 0 16%;
    @media only screen and (max-width: 480px) {
      padding: 0;
    }
  }

  .title {
    margin-top: 30px;
  }
  .c_004 h2 {
    border-bottom: 0px;
  }
  .c_004 .heading-group {
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Form.vue